import React from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';

import { Logo } from 'common/components/Logo';
import { Link } from 'common/components/Link';
import { getIntlPath } from 'common/utils';
import BACKGROUND_IMAGE from 'assets/images/base-background-image.jpg';

const LeftSection = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: ${({ theme }) => theme.palette.background.paper};
    padding: ${({ theme }) => `${theme.spacing(6)}px ${theme.spacing(8)}px`};

    .logoLink {
        text-decoration: none;
        margin-bottom: ${({ theme }) => `${theme.spacing(7)}px`};
    }

    ${Logo} {
        height: 100%;

        .logoWrapper {
            width: 74px;
            margin-right: ${({ theme }) => `${theme.spacing(1)}px`};
        }

        .MuiTypography-root {
            font-size: ${({ theme }) => theme.typography.body2.fontSize};
            line-height: 1;
        }

        svg {
            height: 56px;
        }
    }

    @media (min-width: ${({ theme }) =>
            `${theme.breakpoints.values['md']}px`}) {
        max-width: 565px;
        padding: ${({ theme }) =>
            `${theme.spacing(12)}px ${theme.spacing(8)}px`};

        .logoLink {
            margin-bottom: ${({ theme }) => `${theme.spacing(14)}px`};
        }

        ${Logo} {
            height: 100%;

            .logoWrapper {
                width: 95px;
                margin-right: ${({ theme }) => `${theme.spacing(1)}px`};
            }

            .MuiTypography-root {
                font-size: 2.2rem;
                line-height: 1;
            }

            svg {
                height: 55px;
            }
        }
    }
`;

const RightSection = styled(Box)`
    width: 100%;
    background-image: url(${BACKGROUND_IMAGE});
    background-repeat: no-repeat;
    background-size: cover;
    display: none;

    @media (min-width: ${({ theme }) =>
            `${theme.breakpoints.values['md']}px`}) {
        display: block;
    }
`;

interface IProps {
    className?: string;
}

export const AuthPage: React.FC<IProps> = ({ children, className }) => (
    <Box className={className}>
        <LeftSection>
            <Link className="logoLink" to={getIntlPath('login')}>
                <Logo />
            </Link>
            {children}
        </LeftSection>
        <RightSection />
    </Box>
);

export const BaseAuthPage = styled(AuthPage)`
    display: flex;
    min-height: 100%;
`;
